export const climates = [
  "tropical",
  "dry",
  "temperate",
  "continental",
  "polar"
]

const capitals = [
  { Alpha2Code: "AD", name: "Andorra la Vella", category: "", climate: 2 },
  { Alpha2Code: "AE", name: "Abu Dhabi", category: "Abud_Dabhi_United_Arab_Emirates_Zayed_Mosque", climate: 1 },
  { Alpha2Code: "AF", name: "Kabul", category: "", climate: 3 },
  { Alpha2Code: "AG", name: "Saint John's", category: "", climate: 0 },
  { Alpha2Code: "AI", name: "The Valley", category: "", climate: 0 },
  { Alpha2Code: "AL", name: "Tirana", category: "", climate: 2 },
  { Alpha2Code: "AM", name: "Yerevan", category: "", climate: 3 },
  { Alpha2Code: "AO", name: "Luanda", category: "", climate: 0 },
  { Alpha2Code: "AR", name: "Buenos Aires", category: "", climate: 2 },
  { Alpha2Code: "AS", name: "Pago Pago", category: "", climate: 0 },
  { Alpha2Code: "AT", name: "Vienna", category: "Vienna_Austria_Schonbrunn_Palace", climate: 2 },
  { Alpha2Code: "AU", name: "Canberra", category: "Canberrra_Australia_Parliament", climate: 2 },
  { Alpha2Code: "AW", name: "Oranjestad", category: "", climate: 0 },
  { Alpha2Code: "AZ", name: "Baku", category: "", climate: 2 },
  { Alpha2Code: "BA", name: "Sarajevo", category: "", climate: 2 },
  { Alpha2Code: "BB", name: "Bridgetown", category: "", climate: 0 },
  { Alpha2Code: "BD", name: "Dhaka", category: "", climate: 0 },
  { Alpha2Code: "BE", name: "Brussels", category: "", climate: 2 },
  { Alpha2Code: "BF", name: "Ouagadougou", category: "", climate: 0 },
  { Alpha2Code: "BG", name: "Sofia", category: "", climate: 2 },
  { Alpha2Code: "BH", name: "Manama", category: "", climate: 1 },
  { Alpha2Code: "BI", name: "Gitega", category: "", climate: 0 },
  { Alpha2Code: "BJ", name: "Porto-Novo", category: "", climate: 0 },
  { Alpha2Code: "BM", name: "Hamilton", category: "", climate: 0 },
  { Alpha2Code: "BN", name: "Bandar Seri Begawan", category: "", climate: 0 },
  { Alpha2Code: "BO", name: "La Paz", category: "", climate: 2 },
  { Alpha2Code: "BR", name: "Brasilia", category: "Brasilia_Brazil_Catedral_Metropolitano", climate: 0 },
  { Alpha2Code: "BS", name: "Nassau", category: "", climate: 0 },
  { Alpha2Code: "BT", name: "Thimphu", category: "", climate: 2 },
  { Alpha2Code: "BW", name: "Gaborone", category: "", climate: 1  },
  { Alpha2Code: "BY", name: "Minsk", category: "", climate: 2 },
  { Alpha2Code: "BZ", name: "Belmopan", category: "", climate: 0 },
  { Alpha2Code: "CA", name: "Ottawa", category: "Ottawa_Canada_Parliament", climate: 3 },
  { Alpha2Code: "CC", name: "West Island", category: "", climate: 0 },
  { Alpha2Code: "CD", name: "Kinshasa", category: "", climate: 0 },
  { Alpha2Code: "CF", name: "Bangui", category: "", climate: 0 },
  { Alpha2Code: "CG", name: "Brazzaville", category: "", climate: 0 },
  { Alpha2Code: "CH", name: "Bern", category: "", climate: 2 },
  { Alpha2Code: "CI", name: "Yamoussoukro", category: "", climate: 0 },
  { Alpha2Code: "CK", name: "Avarua", category: "", climate: 0 },
  { Alpha2Code: "CL", name: "Santiago", category: "", climate: 2 },
  { Alpha2Code: "CM", name: "Yaounde", category: "", climate: 0 },
  { Alpha2Code: "CN", name: "Beijing", category: "Beijing_China_Forbidden_City", climate: 2 },
  { Alpha2Code: "CO", name: "Bogota", category: "", climate: 0 },
  { Alpha2Code: "CR", name: "San Jose", category: "", climate: 0 },
  { Alpha2Code: "CU", name: "Havana", category: "", climate: 0 },
  { Alpha2Code: "CV", name: "Praia", category: "", climate: 0 },
  { Alpha2Code: "CW", name: "Willemstad", category: "", climate: 0 },
  { Alpha2Code: "CX", name: "Flying Fish Cove", category: "", climate: 0 },
  { Alpha2Code: "CY", name: "Nicosia", category: "", climate: 2 },
  { Alpha2Code: "CZ", name: "Prague", category: "Prague_Czech_Republic_Prague_Castle", climate: 2 },
  { Alpha2Code: "DE", name: "Berlin", category: "Berlin_Germany_Brandenburg_Gate", climate: 2 },
  { Alpha2Code: "DJ", name: "Djibouti", category: "", climate: 0 },
  { Alpha2Code: "DK", name: "Copenhagen", category: "", climate: 2 },
  { Alpha2Code: "DM", name: "Roseau", category: "", climate: 0 },
  { Alpha2Code: "DO", name: "Santo Domingo", category: "", climate: 0 },
  { Alpha2Code: "DZ", name: "Algiers", category: "", climate: 2 },
  { Alpha2Code: "EC", name: "Quito", category: "", climate: 0 },
  { Alpha2Code: "EE", name: "Tallinn", category: "", climate: 2 },
  { Alpha2Code: "EG", name: "Cairo", category: "Cairo_Egypt_Mosque_of_Muhammad_Ali", climate: 1  },
  { Alpha2Code: "EH", name: "El Aaiún", category: "", climate: 1  },
  { Alpha2Code: "ER", name: "Asmara", category: "", climate: 0 },
  { Alpha2Code: "ES", name: "Madrid", category: "Madrid_Spain_Royal_Palace", climate: 2 },
  { Alpha2Code: "ET", name: "Addis Ababa", category: "", climate: 0 },
  { Alpha2Code: "FI", name: "Helsinki", category: "Helsinki_Finland_Helsinki_Cathedral", climate: 2 },
  { Alpha2Code: "FJ", name: "Suva", category: "", climate: 0 },
  { Alpha2Code: "FK", name: "Stanley", category: "", climate: 4 },
  { Alpha2Code: "FM", name: "Palikir", category: "", climate: 0 },
  { Alpha2Code: "FO", name: "Tórshavn", category: "", climate: 4 },
  { Alpha2Code: "FR", name: "Paris", category: "Paris_France_Eiffel_Tower", climate: 2 },
  { Alpha2Code: "GA", name: "Libreville", category: "", climate: 0 },
  { Alpha2Code: "GB", name: "London", category: "London_United_kingdom_Tower_Brigde", climate: 2 },
  { Alpha2Code: "GD", name: "St. George's", category: "", climate: 0 },
  { Alpha2Code: "GE", name: "Tbilisi", category: "", climate: 0 },
  { Alpha2Code: "GF", name: "Cayenne", category: "", climate: 0 },
  { Alpha2Code: "GG", name: "St. Peter Port", category: "", climate: 2 },
  { Alpha2Code: "GH", name: "Accra", category: "", climate: 0 },
  { Alpha2Code: "GI", name: "Gibraltar", category: "", climate: 2 },
  { Alpha2Code: "GL", name: "Nuuk", category: "Nuuk_Greenland_Independence_sculpture", climate: 4 },
  { Alpha2Code: "GM", name: "Banjul", category: "", climate: 0 },
  { Alpha2Code: "GN", name: "Conakry", category: "", climate: 0 },
  { Alpha2Code: "GP", name: "Basse-Terre", category: "", climate: 0 },
  { Alpha2Code: "GQ", name: "Malabo", category: "", climate: 0 },
  { Alpha2Code: "GR", name: "Athens", category: "Athens_Greece_Acropolis", climate: 2 },
  { Alpha2Code: "GS", name: "King Edward Point", category: "", climate: 4 },
  { Alpha2Code: "GT", name: "Guatemala City", category: "", climate: 2 },
  { Alpha2Code: "GU", name: "Hagatna", category: "", climate: 0 },
  { Alpha2Code: "GW", name: "Bissau", category: "", climate: 0 },
  { Alpha2Code: "GY", name: "Georgetown", category: "", climate: 0 },
  { Alpha2Code: "HN", name: "Tegucigalpa", category: "", climate: 0 },
  { Alpha2Code: "HR", name: "Zagreb", category: "", climate: 2 },
  { Alpha2Code: "HT", name: "Port-au-Prince", category: "", climate: 0 },
  { Alpha2Code: "HU", name: "Budapest", category: "Budapest_Hungary_Parliament_building", climate: 2 },
  { Alpha2Code: "ID", name: "Jakarta", category: "Jakarta_Indonesia_Istiqlal_Mosque", climate: 0 },
  { Alpha2Code: "IE", name: "Dublin", category: "", climate: 2 },
  { Alpha2Code: "IL", name: "Jerusalem", category: "", climate: 2 },
  { Alpha2Code: "IM", name: "Douglas", category: "", climate: 2 },
  { Alpha2Code: "IN", name: "New Delhi", category: "New_Delhi_India_Humanyu_Tumb", climate: 0 },
  { Alpha2Code: "IQ", name: "Baghdad", category: "", climate: 1  },
  { Alpha2Code: "IR", name: "Tehran", category: "Tehran_Iran_Azadi_Tower", climate: 1  },
  { Alpha2Code: "IS", name: "Reykjavik", category: "Reykjavik_Iceland_Hallgrimskirkj", climate: 4 },
  { Alpha2Code: "IT", name: "Rome", category: "Rome_Italy_Colosseum", climate: 2 },
  { Alpha2Code: "JE", name: "Saint Helier", category: "", climate: 2 },
  { Alpha2Code: "JM", name: "Kingston", category: "", climate: 0 },
  { Alpha2Code: "JO", name: "Amman", category: "", climate: 2 },
  { Alpha2Code: "JP", name: "Tokyo", category: "Tokyo_Japan_Tokyo_Tower", climate: 2 },
  { Alpha2Code: "KE", name: "Nairobi", category: "", climate: 0 },
  { Alpha2Code: "KG", name: "Bishkek", category: "", climate: 3 },
  { Alpha2Code: "KH", name: "Phnom Penh", category: "", climate: 0 },
  { Alpha2Code: "KI", name: "Tarawa", category: "", climate: 0 },
  { Alpha2Code: "KM", name: "Moroni", category: "", climate: 0 },
  { Alpha2Code: "KN", name: "Basseterre", category: "", climate: 0 },
  { Alpha2Code: "KP", name: "Pyongyang", category: "", climate: 3 },
  { Alpha2Code: "KR", name: "Seoul", category: "Seoul_South_Korea_N_Seoul_Tower", climate: 2 },
  { Alpha2Code: "KW", name: "Kuwait City", category: "", climate: 1  },
  { Alpha2Code: "KY", name: "George Town", category: "", climate: 0 },
  { Alpha2Code: "KZ", name: "Astana", category: "", climate: 3 },
  { Alpha2Code: "LA", name: "Vientiane", category: "", climate: 0 },
  { Alpha2Code: "LB", name: "Beirut", category: "", climate: 2 },
  { Alpha2Code: "LC", name: "Castries", category: "", climate: 0 },
  { Alpha2Code: "LI", name: "Vaduz", category: "", climate: 3 },
  { Alpha2Code: "LK", name: "Colombo", category: "", climate: 0 },
  { Alpha2Code: "LR", name: "Monrovia", category: "", climate: 0 },
  { Alpha2Code: "LS", name: "Maseru", category: "", climate: 0 },
  { Alpha2Code: "LT", name: "Vilnius", category: "", climate: 2 },
  { Alpha2Code: "LU", name: "Luxembourg", category: "", climate: 2 },
  { Alpha2Code: "LV", name: "Riga", category: "", climate: 2 },
  { Alpha2Code: "LY", name: "Tripoli", category: "", climate: 2 },
  { Alpha2Code: "MA", name: "Rabat", category: "", climate: 2 },
  { Alpha2Code: "MC", name: "Monaco", category: "", climate: 2 },
  { Alpha2Code: "MD", name: "Chisinau", category: "", climate: 3 },
  { Alpha2Code: "ME", name: "Podgorica", category: "", climate: 2 },
  { Alpha2Code: "MG", name: "Antananarivo", category: "", climate: 0 },
  { Alpha2Code: "MH", name: "Majuro", category: "", climate: 0 },
  { Alpha2Code: "MK", name: "Skopje", category: "", climate: 3 },
  { Alpha2Code: "ML", name: "Bamako", category: "", climate: 0 },
  { Alpha2Code: "MM", name: "Naypyidaw", category: "", climate: 0 },
  { Alpha2Code: "MN", name: "Ulan Bator", category: "", climate: 3 },
  { Alpha2Code: "MP", name: "Saipan", category: "", climate: 0 },
  { Alpha2Code: "MQ", name: "Fort-de-France", category: "", climate: 0 },
  { Alpha2Code: "MR", name: "Nouakchott", category: "", climate: 1  },
  { Alpha2Code: "MS", name: "Plymouth", category: "", climate: 0 },
  { Alpha2Code: "MT", name: "Valletta", category: "", climate: 2 },
  { Alpha2Code: "MU", name: "Port Louis", category: "", climate: 0 },
  { Alpha2Code: "MV", name: "Male", category: "", climate: 0 },
  { Alpha2Code: "MW", name: "Lilongwe", category: "", climate: 0 },
  { Alpha2Code: "MX", name: "Mexico City", category: "Mexico_City_Mexico_Angel_de_la_Independencia", climate: 0 },
  { Alpha2Code: "MY", name: "Kuala Lumpur", category: "Kuala_Lumpur_Malaysia_Petronas_Towers", climate: 0 },
  { Alpha2Code: "MZ", name: "Maputo", category: "", climate: 0 },
  { Alpha2Code: "NA", name: "Windhoek", category: "", climate: 1  },
  { Alpha2Code: "NC", name: "Noumea", category: "", climate: 0 },
  { Alpha2Code: "NE", name: "Niamey", category: "", climate: 1  },
  { Alpha2Code: "NF", name: "Kingston", category: "", climate: 0 },
  { Alpha2Code: "NG", name: "Abuja", category: "", climate: 0 },
  { Alpha2Code: "NI", name: "Managua", category: "", climate: 0 },
  { Alpha2Code: "NL", name: "Amsterdam", category: "Amsterdam_Netherlands_Canals_and_historic_houses", climate: 2 },
  { Alpha2Code: "NO", name: "Oslo", category: "Oslo_Norway_Nobel_Peace_Center", climate: 2 },
  { Alpha2Code: "NP", name: "Kathmandu", category: "", climate: 0 },
  { Alpha2Code: "NR", name: "Yaren", category: "", climate: 0 },
  { Alpha2Code: "NU", name: "Alofi", category: "", climate: 0 },
  { Alpha2Code: "NZ", name: "Wellington", category: "", climate: 2 },
  { Alpha2Code: "OM", name: "Muscat", category: "", climate: 1  },
  { Alpha2Code: "PA", name: "Panama City", category: "", climate: 0 },
  { Alpha2Code: "PE", name: "Lima", category: "", climate: 0 },
  { Alpha2Code: "PF", name: "Papeete", category: "", climate: 0 },
  { Alpha2Code: "PG", name: "Port Moresby", category: "", climate: 0 },
  { Alpha2Code: "PH", name: "Manila", category: "", climate: 0 },
  { Alpha2Code: "PK", name: "Islamabad", category: "", climate: 0 },
  { Alpha2Code: "PL", name: "Warsaw", category: "", climate: 2 },
  { Alpha2Code: "PM", name: "Saint-Pierre", category: "", climate: 4 },
  { Alpha2Code: "PN", name: "Adamstown", category: "", climate: 2 },
  { Alpha2Code: "PR", name: "San Juan", category: "", climate: 0 },
  { Alpha2Code: "PS", name: "Ramallah", category: "", climate: 2 },
  { Alpha2Code: "PT", name: "Lisbon", category: "Lisbon_Portugal_Torre_de_Belem", climate: 2 },
  { Alpha2Code: "PY", name: "Asuncion", category: "", climate: 0 },
  { Alpha2Code: "QA", name: "Doha", category: "", climate: 1  },
  { Alpha2Code: "RE", name: "Saint-Denis", category: "", climate: 0 },
  { Alpha2Code: "RO", name: "Bucharest", category: "", climate: 2 },
  { Alpha2Code: "RS", name: "Belgrade", category: "", climate: 3 },
  { Alpha2Code: "RU", name: "Moscow", category: "Moscow_Russia_St._Basil's_Cathedral", climate: 3 },
  { Alpha2Code: "RW", name: "Kigali", category: "", climate: 2 },
  { Alpha2Code: "SA", name: "Riyadh", category: "Riyadh_Saudi_Arabia_Kingdom_Centre", climate: 1  },
  { Alpha2Code: "SB", name: "Honiara", category: "", climate: 0 },
  { Alpha2Code: "SC", name: "Victoria", category: "", climate: 0 },
  { Alpha2Code: "SD", name: "Khartoum", category: "", climate: 1  },
  { Alpha2Code: "SE", name: "Stockholm", category: "", climate: 2 },
  { Alpha2Code: "SG", name: "Singapore", category: "", climate: 0 },
  { Alpha2Code: "SH", name: "Jamestown", category: "", climate: 0 },
  { Alpha2Code: "SI", name: "Ljubljana", category: "", climate: 2 },
  { Alpha2Code: "SJ", name: "Longyearbyen", category: "", climate: 4 },
  { Alpha2Code: "SK", name: "Bratislava", category: "", climate: 2 },
  { Alpha2Code: "SL", name: "Freetown", category: "", climate: 0 },
  { Alpha2Code: "SM", name: "San Marino", category: "", climate: 2 },
  { Alpha2Code: "SN", name: "Dakar", category: "", climate: 0 },
  { Alpha2Code: "SO", name: "Mogadishu", category: "", climate: 0 },
  { Alpha2Code: "SR", name: "Paramaribo", category: "", climate: 0 },
  { Alpha2Code: "SS", name: "Juba", category: "", climate: 0 },
  { Alpha2Code: "ST", name: "Sao Tome", category: "", climate: 0 },
  { Alpha2Code: "SV", name: "San Salvador", category: "", climate: 0 },
  { Alpha2Code: "SY", name: "Damascus", category: "", climate: 2 },
  { Alpha2Code: "SZ", name: "Mbabane", category: "", climate: 0 },
  { Alpha2Code: "TC", name: "Cockburn Town", category: "", climate: 0 },
  { Alpha2Code: "TD", name: "N'Djamena", category: "", climate: 0 },
  { Alpha2Code: "TF", name: "Port-aux-Francais", category: "", climate: 4 },
  { Alpha2Code: "TG", name: "Lome", category: "", climate: 0 },
  { Alpha2Code: "TH", name: "Bangkok", category: "Bangkok_Thailand_Wat_Arun_Temple_of_Dawn", climate: 0 },
  { Alpha2Code: "TJ", name: "Dushanbe", category: "", climate: 3 },
  { Alpha2Code: "TL", name: "Dili", category: "", climate: 0 },
  { Alpha2Code: "TM", name: "Ashgabat", category: "", climate: 1  },
  { Alpha2Code: "TN", name: "Tunis", category: "", climate: 2 },
  { Alpha2Code: "TO", name: "Nuku'alofa", category: "", climate: 0 },
  { Alpha2Code: "TR", name: "Ankara", category: "Ankara_Turkey_Kocatepe_Mosque", climate: 2 },
  { Alpha2Code: "TT", name: "Port of Spain", category: "", climate: 0 },
  { Alpha2Code: "TV", name: "Funafuti", category: "", climate: 0 },
  { Alpha2Code: "TW", name: "Taipei", category: "", climate: 0 },
  { Alpha2Code: "TZ", name: "Dodoma", category: "", climate: 0 },
  { Alpha2Code: "UA", name: "Kyiv", category: "", climate: 3 },
  { Alpha2Code: "UG", name: "Kampala", category: "", climate: 0 },
  { Alpha2Code: "US", name: "Washington, D.C.", category: "Washington_DC_USA_Capitol", climate: 2 },
  { Alpha2Code: "UY", name: "Montevideo", category: "", climate: 0 },
  { Alpha2Code: "UZ", name: "Tashkent", category: "", climate: 3 },
  { Alpha2Code: "VA", name: "Vatican City", category: "", climate: 2 },
  { Alpha2Code: "VC", name: "Kingstown", category: "", climate: 0 },
  { Alpha2Code: "VE", name: "Caracas", category: "", climate: 0 },
  { Alpha2Code: "VG", name: "Road Town", category: "", climate: 0 },
  { Alpha2Code: "VI", name: "Charlotte Amalie", category: "", climate: 0 },
  { Alpha2Code: "VN", name: "Hanoi", category: "", climate: 0 },
  { Alpha2Code: "VU", name: "Port Vila", category: "", climate: 0 },
  { Alpha2Code: "WF", name: "Mata-Utu", category: "", climate: 0 },
  { Alpha2Code: "WS", name: "Apia", category: "", climate: 0 },
  { Alpha2Code: "XK", name: "Pristina", category: "", climate: 3 },
  { Alpha2Code: "YE", name: "Sanaa", category: "", climate: 1  },
  { Alpha2Code: "YT", name: "Mamoudzou", category: "", climate: 0 },
  { Alpha2Code: "ZA", name: "Pretoria", category: "Cape_Town_South_Africa_Table_Mountain", climate: 0 },
  { Alpha2Code: "ZM", name: "Lusaka", category: "", climate: 0 },
  { Alpha2Code: "ZW", name: "Harare", category: "", climate: 0 },
];

export default capitals;
